export enum GaFormStep {
  SelectTime = '1. Weiter zur Uhrzeit',
  TimeSelected = '2. Uhrzeit gewählt',
  SecureAppointment = '3. Wunschtermin sichern',
}
